<div class="date-picker-container" [ngClass]="{ 'has-errors': hasErrors }">
  <boi-validation-error-generic
    (errorChange)="onErrorChange($event)"
    [validationErrors]="validationErrors"
    [propertyNames]="validationPropertyNames"
  >
  </boi-validation-error-generic>

  <kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
      <div class="field-label" *ngIf="labelName" [boiRequiredFormField]="required ? labelName : undefined">
        <div class="label-content">
          <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName | localizeLabel"></label>
          <ng-content></ng-content>
        </div>
        <boi-tooltip
          *ngIf="showTooltip && !isTooltipLast"
          [tooltipName]="tooltipName ? tooltipName : labelName"
        ></boi-tooltip>
      </div>
      <div class="field-input" [ngClass]="{ 'hide-calendar': !showCalendar }">
        <kendo-datepicker
          [id]="controlId ? controlId : labelName"
          [placeholder]="placeholder"
          [format]="format"
          [(ngModel)]="value"
          [disabled]="isFieldDisabled"
          [min]="min"
          [max]="max"
          (blur)="onBlur()"
          [popupSettings]="{ animate: false, appendTo: 'component' }"
        >
        </kendo-datepicker>
      </div>
    </div>
    <boi-tooltip *ngIf="showTooltip && isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName">
    </boi-tooltip>
  </kendo-textbox-container>
</div>
